import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';

interface BaseTextStrokeColorOptionProps {
  className?: string;
  outlineColorOptionLabel?: string;
  strokeColor: RGBA;
  onClickColorFill(): void;
}

export function BaseTextStrokeColorOption({
  className = '',
  outlineColorOptionLabel = window.i18next.t('pmwjs_color'),
  ...props
}: BaseTextStrokeColorOptionProps): ReactElement<any> | null {
  const getStrokeColorObject = (): ColorFillStorage[] => {
    return [
      {
        id: 'stroke-color-object',
        color: getColorObjectArrayFromFillColor([props.strokeColor]),
      },
    ];
  };

  const onClickColorFill = (): void => {
    props.onClickColorFill();
  };

  return (
    <ContextualMenuColorFillOption className={className} id="item-outline-color-option" label={outlineColorOptionLabel} data={getStrokeColorObject()} onClick={onClickColorFill} />
  );
}
